module.exports = __webpack_public_path__ + "img/wake_forecast.b40d6224.svg";